import React from "react";
import { Col, Container, Row } from "reactstrap";
import { getPayloadMedia } from "../../services/payloadService";
import parseHtml from "../../utils/parseHtml";
import { Link } from "react-router-dom";
export default function ServiciosSection({ data }) {
    const { tituloSeccion, subtituloSeccion, imagenFondo, servicios, blockType, __component } = data;
    const ancla = blockType || __component?.split('.')[1] || 'servicios';

    if (!servicios || servicios.length === 0) return null;

    return (
        <section
            className="section p-0 bg-white"
            id={ancla}
            style={imagenFondo ? { background: `url(${getPayloadMedia(imagenFondo.url || imagenFondo[0]?.url)}) top` } : {}}
        >
            <Container>
                <div className="row justify-content-center">
                    <Col lg={12}>
                        <div className="features-absolute rounded shadow px-4 py-5 bg-primary">
                            {tituloSeccion && (
                                <div className="row">
                                    <div className="col">
                                        <div className="section-title mb-4 pb-2">
                                            <h4 className="title mb-3 text-white">{tituloSeccion}</h4>
                                            {subtituloSeccion && (
                                                <p className="text-white para-desc mb-0">{parseHtml(subtituloSeccion)}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            <Row>
                                {servicios.map((servicio, index) => (
                                    <div key={index} className={`col-lg-4 col-md-6 d-lg-flex justify-content-lg-center align-items-lg-center ${index >= 3 ? 'mt-4 pt-4' : index > 0 ? 'mt-4 pt-4 mt-sm-0 pt-sm-0' : ''} ${index === 2 ? 'mt-lg-0 pt-lg-0' : ''}`}>
                                        <div className="d-flex features feature-primary">
                                            <div className="feature-icon text-center" >
                                                <Link to={servicio.url || "#"} className="text-decoration-none text-white">
                                                <i className={`${servicio.icono} rounded h4 text-white`} style={{ borderColor: 'white' }}></i>
                                                </Link>
                                            </div>
                                            <div className="flex-1 ms-3">
                                                <h5 className="mt-0 text-white">{servicio.titulo}</h5>
                                                <p className="text-white mb-0">{parseHtml(servicio.descripcion)}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Row>
                        </div>
                    </Col>
                </div>
            </Container>
        </section>
    );
}
